module.exports = "https://web-assets.ifttt.com/packs/media/icons/icon-filter-88828e3e.svg";